export default "__VITE_ASSET__CC0KW2Ni__"